import React from 'react';
const bonuses = [{
  num: '01',
  title: 'Kit SSOMA Completo',
  desc: 'Todos los formatos, PETS, exámenes y manuales de seguridad listos para presentar en auditoría.',
  value: '8.500',
  color: 'bg-blue-600'
}, {
  num: '02',
  title: 'Capacitación Minera Express',
  desc: 'Word, PPTs, exámenes y manuales para capacitar a tu equipo desde el día 1.',
  value: '6.500',
  color: 'bg-teal-600'
}, {
  num: '03',
  title: 'Plantillas de Evaluación Económica',
  desc: 'Planillas Excel pre-armadas para evaluación de proyectos y optimización de pit.',
  value: '5.500',
  color: 'bg-amber-600'
}];
export function BonusSection() {
  return <section className="py-14 md:py-24 px-4 bg-brand-dark text-white" data-id="element-19">
      <div className="max-w-6xl mx-auto" data-id="element-20">
        <div className="text-center mb-8 md:mb-16" data-id="element-21">
          <h2 className="text-3xl md:text-6xl font-black text-brand-orange mb-4 md:mb-6 uppercase tracking-tight" data-id="element-22">
            Más 3 Bonos Estratégicos
          </h2>
          <p className="text-2xl font-bold text-gray-300 mb-4" data-id="element-23">
            Incluidos en todas las ofertas — sin costo extra
          </p>
          <div className="inline-block bg-brand-green text-white text-2xl font-black px-8 py-3 rounded-full animate-pulse-fast shadow-[0_0_20px_rgba(0,178,122,0.5)]" data-id="element-24">
            🎁 GRATIS por el día de hoy
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8 mb-10 md:mb-16" data-id="element-25">
          {bonuses.map((b, i) => <div key={i} className="bg-[#252542] rounded-2xl overflow-hidden border border-gray-700 shadow-2xl flex flex-col h-full" data-id="element-26">
              {/* Compact header section - reduced on mobile */}
              <div className={`${b.color} p-4 md:p-8 flex flex-col items-center justify-center text-center relative min-h-[140px] md:min-h-[200px]`} data-id="element-27">
                <div className="absolute top-3 left-3 md:top-4 md:left-4 bg-white text-black font-black text-lg md:text-2xl px-3 py-1 md:px-4 md:py-1 rounded-lg" data-id="element-28">
                  {b.num}
                </div>
                <h3 className="text-2xl md:text-4xl font-black text-white leading-tight drop-shadow-md" data-id="element-29">
                  BONO {parseInt(b.num)}
                </h3>
                <p className="text-base md:text-xl font-bold mt-2 md:mt-4 text-white/90 drop-shadow-md px-2 md:px-4" data-id="element-30">
                  {b.title}
                </p>
              </div>

              <div className="p-5 md:p-8 flex flex-col flex-grow" data-id="element-31">
                <p className="text-gray-300 text-lg mb-8 flex-grow" data-id="element-32">{b.desc}</p>

                <div className="mt-auto pt-6 border-t border-gray-700 flex justify-between items-center" data-id="element-33">
                  <div className="text-gray-400 font-medium" data-id="element-34">
                    Valor: <span className="line-through" data-id="element-35">${b.value}</span>
                  </div>
                  <div className="text-brand-green font-black text-2xl" data-id="element-36">
                    GRATIS
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-[#252542] border-2 border-brand-orange rounded-2xl p-5 md:p-8 text-center max-w-3xl mx-auto" data-id="element-37">
          <p className="text-2xl text-gray-300 mb-2" data-id="element-38">
            Valor total de los 3 Bonos:{' '}
            <span className="line-through" data-id="element-39">$20.500 ARS</span>
          </p>
          <p className="text-3xl md:text-4xl font-black text-brand-green" data-id="element-40">
            🎁 GRATIS — Solo con tu compra. Siempre.
          </p>
        </div>
      </div>
    </section>;
}